// import { Button } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import Accordion from "@mui/material/Accordion";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import Typography from "@mui/material/Typography";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import axios from "axios";
// import { useEffect, useState } from "react";
// import { useFormik } from "formik";

// function Career() {
//   const navigate = useNavigate();
//   const [career, setCareer] = useState([]);
//   useEffect(() => {
//     const url =
//       "https://m1blog.aaragroups.com/blog/api/admin/api/job_list_api/";

//     axios
//       .get(url, {
//         headers: { Token: "fa1286bc48bbc4454a44f4b84d8838bbf3ff2794" },
//       })
//       .then((res) => console.log(res.data?.data))
//       .catch((err) => console.log("err"));
//   }, []);
//   console.log(career);

//   const formik = useFormik({
//     initialValues: {
//       first_name: "",
//       last_name: "",
//       email: "",
//       mobile_no: "",
//       candiate_messages: "",
//       candiate_type: "",
//       experience: "",
//       cv: "",
//     },

//     onSubmit: (values, action) => {
//       const reqBody = new FormData();
//       reqBody.append("first_name", values.first_name);
//       reqBody.append("last_name", values.last_name);
//       reqBody.append("email", values.email);
//       reqBody.append("mobile_no", values.mobile_no);
//       reqBody.append("candiate_messages", values.candiate_messages);
//       reqBody.append("candiate_type", "ONLINE/AARATECH");
//       reqBody.append("candiate_messages", values.candiate_messages);
//       reqBody.append("experience", values.experience);
//       reqBody.append("cv", values.cv);

//       axios
//         .post(
//           "https://b1.bhaaraterp.com/Api_data/career-page-API-with-CV-attachment/",
//           reqBody,
//           {
//             headers: {
//               token: "c0951c5b80621b873302bc6d68669bdfe7876f73",
//               "Access-Control-Allow-Origin": "*",
//             },
//           }
//         )
//         .then((res) => {
//           console.log("RESPONSE ==== : ", res);
//           alert(res.data.message);
//         })
//         .catch((err) => {
//           console.log("ERROR: ====", err);
//           alert(err.response.data.message);
//         });
//       action.resetForm();
//     },
//   });
//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: "smooth",
//     });
//   }, []);

//   return (
//     <div className="jj">
//       <div className=" pt-40">
//         <p className="text-3xl text-center text-white">Job Opening</p>

//         <div className="flex justify-center pt-20 gap-10 ">
//           <div className="flex flex-col text-white">
//             <p className="p-2 pt-5 text-white text-center text-3xl">
//               We Are With You In Your Success.
//             </p>

//             <p className="p-2  text-center text-white text-xl">
//               Send Your Resume At:
//             </p>
//             <p className="p-2  text-center text-white text-xl">
//               hr@aaratechnologies.in
//             </p>
//             <div className="lg:px-5">
//               <div className="lg:px-5 px-3 pt-20">
//                 <div
//                   className=" bg-gray-400 px-8 rounded-md bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-40 border border-gray-100
//                     "
//                 >
//                   <p className="text-4xl p-2 text-center text-white pt-5">
//                     Apply for jobs
//                   </p>
//                   <div className="lg:px-5 px-3 py-10 flex-col justify-center flex gap-5  ">
//                     <form
//                       onSubmit={formik.handleSubmit}
//                       class="form"
//                       method="post"
//                     >
//                       <div className="flex flex-col lg:flex-row gap-5 py-2 ">
//                         <input
//                           type="text"
//                           name="first_name"
//                           id="first_name"
//                           class="form-control"
//                           placeholder="First Name"
//                           value={formik.values["first_name"]}
//                           onChange={formik.handleChange}
//                           className="border border-black p-1 rounded text-black lg:ml-0 ml-10 "
//                         />
//                       </div>
//                       <div className="flex flex-col lg:flex-row gap-5 py-2 w">
//                         <input
//                           type="text"
//                           name="last_name"
//                           id="last_name"
//                           class="form-control"
//                           placeholder="last Name"
//                           value={formik.values["last_name"]}
//                           onChange={formik.handleChange}
//                           className="border border-black p-1 text-black rounded  lg:ml-0 ml-10"
//                         />{" "}
//                       </div>
//                       <div className="flex flex-col lg:flex-row gap-5 py-2 w">
//                         <input
//                           type="text"
//                           name="email"
//                           id="email"
//                           class="form-control"
//                           placeholder="Email"
//                           value={formik.values["email"]}
//                           onChange={formik.handleChange}
//                           className="border border-black p-1 rounded text-black lg:ml-0 ml-10"
//                         />
//                       </div>
//                       <div className="flex flex-col lg:flex-row gap-5 py-2 w">
//                         <input
//                           type="number"
//                           name="mobile_no"
//                           id="mobile_no"
//                           class="form-control"
//                           placeholder="Mobile number"
//                           value={formik.values["mobile_no"]}
//                           onChange={formik.handleChange}
//                           className="border border-black p-1 rounded text-black lg:ml-0 ml-10"
//                         />
//                       </div>
//                       <div className="flex flex-col lg:flex-row gap-5 py-2 w">
//                         <input
//                           type="text"
//                           name="candiate_messages"
//                           id="candiate_messages"
//                           class="form-control"
//                           placeholder="Message"
//                           value={formik.values["candiate_messages"]}
//                           onChange={formik.handleChange}
//                           className="border border-black p-1 rounded text-black lg:ml-0 ml-10"
//                         />
//                       </div>
//                       <div className="flex flex-col lg:flex-row gap-5 py-2 w">
//                         <input
//                           type="text"
//                           name="experience"
//                           id="experience"
//                           class="form-control"
//                           placeholder="Experience (In year)"
//                           value={formik.values["experience"]}
//                           onChange={formik.handleChange}
//                           className="border border-black p-1 rounded text-black lg:ml-0 ml-10"
//                         />
//                       </div>
//                       <div className="flex flex-col lg:flex-row gap-5 py-2 w">
//                         <input
//                           type="file"
//                           name="cv"
//                           id="cv"
//                           accept="application/pdf, image/jpeg"
//                           placeholder="cv"
//                           value={formik.values["cv"]}
//                           onChange={formik.handleChange}
//                           className="border border-black p-1 rounded text-black lg:ml-0 ml-10 form-control"
//                         />
//                       </div>
//                       <div className="px-10 py-5">
//                         <Button
//                           type="submit"
//                           variant="contained"
//                           className="!w-full !rounded !font-bold !bg-gradient-to-br !from-pink-500 !to-blue-500 !text-white !py-2 !px-4 !focus:outline-none !focus:shadow-outline"
//                         >
//                           Send request
//                         </Button>
//                       </div>
//                     </form>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="flex flex-col text-white">
//             <p className="p-2 pt-5 text-white text-center text-3xl">
//               Here our company jobs Positions.
//             </p>

//             <p className="p-2  text-center text-white text-xl">
//               Open for job postions in Aara Technologies Pvt. Ltd.
//               <br /> It Takes a new kind of Intelligence to nevigate a new
//               world.
//             </p>

//             <div className="pt-20 w-2/3 !ml-20">
//               <Accordion className=" !bg-gray-400 rounded-md !bg-clip-padding !backdrop-filter !backdrop-blur-sm !bg-opacity-40 !border !border-gray-100">
//                 <AccordionSummary
//                   expandIcon={<ExpandMoreIcon />}
//                   aria-controls="panel1a-content"
//                   id="panel1a-header"
//                 >
//                   <Typography>{career.Title}</Typography>
//                 </AccordionSummary>
//                 <AccordionDetails className="!bg-white">
//                   <Typography>
//                     {career.images}
//                     <li>
//                       <h6>Year Of Experience:</h6>

//                       <p className="fw-bold">{career.Experience}</p>
//                     </li>
//                     <li>
//                       <p className="">Gender:{career.Gender}</p>
//                     </li>
//                   </Typography>
//                 </AccordionDetails>
//               </Accordion>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Career;
import React, { useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import {ExpandMore} from "@mui/icons-material"
import { useFormik } from "formik";
import axios from "axios";

const Career = () => {
  const [cv, setCv] = useState(null);
  const [data, setData] = useState([]);

  const [expandeds, setExpandeds] = React.useState("false");
  const handleChanges = (panels) => (events, newExpandeds) => {
    setExpandeds(newExpandeds ? panels : false);
  };

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile_no: "",
      candiate_messages: "",
      candiate_type: "",
      experience: "",
      cv: "",
    },

    onSubmit: (values, action) => {
      const reqBody = new FormData();
      reqBody.append("first_name", values.first_name);
      reqBody.append("last_name", values.last_name);
      reqBody.append("email", values.email);
      reqBody.append("mobile_no", values.mobile_no);
      reqBody.append("candiate_messages", values.candiate_messages);
      reqBody.append("candiate_type", "ONLINE/AARATECH");
      reqBody.append("candiate_messages", values.candiate_messages);
      reqBody.append("experience", values.experience);
      reqBody.append("cv", cv);
      reqBody.append("cv_check", true);

      axios
        .post(
          "https://b1.bhaaraterp.com/Api_data/career-page-API-with-CV-attachment/",
          reqBody,
          {
            headers: {
              token: "c0951c5b80621b873302bc6d68669bdfe7876f73",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((res) => {
          console.log("RESPONSE ==== : ", res);
          alert(res.data.message);
        })
        .catch((err) => {
          console.log("ERROR: ====", err);
          alert(err.response.data.message);
        });
      action.resetForm();
    },
  });

  const careerData = () => {
    axios
      .post("https://m1blog.aaragroups.com/blog/store-based-jobs-list-api/",{store_id:5}, {
        headers: {
        
          "Access-Control-Allow-Origin": "*",
        },

      })
      .then((res) => {
        console.log("RESPONSE ==== : ", res.data?.news_details);
        setData(res.data?.news_details);
      })
      .catch((err) => {
        console.log("ERROR: ====", err);
        alert(err.response.data.message);
      });
  };

  useEffect(() => {
    careerData();
  }, []);
  console.log(data);
  
  return (
    <>
      <div className="hm1  py-5">
        <div id="abc" className="max-h-[450px] lg:max-h-fit">
          <div className="flex flex-col justify-center items-center lg:p-32 p-16 text-white">
            <p className="lg:text-6xl text-4xl font-semibold">Job Opening</p>
          </div>
        </div>

        <div className="lg:flex-row flex flex-col -mt-72 pt-40 ">
          <div className="lg:w-1/2 w-full lg:px-24 px-6 mt-10">
            <p className="lg:text-3xl text-2xl font-semibold text-center text-white py-6">
              We Are With You In Your Success
            </p>
            <p className=" text-lg text-white ">
              Welcome to Aara Technologies Pvt. Ltd. It Takes a new kind of
              Intelligence to nevigate a new world.
            </p>
            <p className="text-xl font-semibold py-2 text-white ">Website</p>
            <p className="text-orange-600 cursor-pointer">www.thecareerads.com</p>
            <p className="text-xl font-semibold py-2">Send your resume at</p>
            <p className="text-orange-600  cursor-pointer">hr@thecareerads.in</p>
            <div className="border p-4 rounded-xl bg-violet-200 mt-3">
              <p className="text-3xl font-semibold text-[#3b368c] py-3">
                Apply For Jobs
              </p>
              <form onSubmit={formik.handleSubmit} method="post">
                <div>
                  <div className="flex gap-2 py-1">

                    <input
                      type="text"
                      name="first_name"
                      id="first_name"
                      placeholder="First Name"
                      value={formik.values["first_name"]}
                      onChange={formik.handleChange}
                      className="border w-full p-2 rounded-lg outline-none"
                    />

                    <input
                      type="text"
                      name="last_name"
                      id="last_name"
                      placeholder="Last Name"
                      value={formik.values["last_name"]}
                      onChange={formik.handleChange}
                      className="border w-full p-2  rounded-lg outline-none"
                    />

                  </div>
                  <div className="flex gap-2 mt-1">
                    <input
                      type="text"
                      name="email"
                      id="email"
                      placeholder="Email"
                      value={formik.values["email"]}
                      onChange={formik.handleChange}
                      className=" rounded-lg outline-none border w-full p-2"
                    />
                    <input
                      type="text"
                      name="mobile_no"
                      id="mobile_no"
                      placeholder="Mobile number"
                      value={formik.values["mobile_no"]}
                      onChange={formik.handleChange}
                      className=" rounded-lg outline-none border w-full p-2"
                    />
                  </div>
                  <div className="flex gap-2 py-1 ">
                    <input
                      type="text"
                      name="candiate_messages"
                      id="candiate_messages"
                      placeholder="Message"
                      value={formik.values["candiate_messages"]}
                      onChange={formik.handleChange}
                      className=" rounded-lg outline-none border w-full p-2 mt-1"
                    />
                  </div>
                  <div className="flex gap-2 py-1">
                    <input
                      type="text"
                      name="experience"
                      id="experience"
                      placeholder="Experience (In year)"
                      value={formik.values["experience"]}
                      onChange={formik.handleChange}
                      className=" rounded-lg outline-none border w-full p-2"
                    />
                  </div>
                  <div className="flex gap-2 py-1">
                    <input
                      type="file"
                      name="cv"
                      id="cv"
                      accept="application/pdf, image/jpeg"
                      placeholder="cv"
                      onChange={(e) => setCv(e.target.files[0])}
                      className=" rounded-lg outline-none border w-full p-2"
                    />
                  </div>
                  <div className="flex justify-center items-center">
                    <button
                      className="text-lg text-white bg-violet-400 p-2 px-4 rounded-full mt-2 font-semibold"
                      type="submit"
                    >
                      SEND YOUR REQUEST
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="lg:w-1/2 w-full lg:px-16 px-5 mt-10">
            <p className="lg:text-3xl text-2xl font-semibold text-white
            text-center py-6">
              Here Our Company Post Positions
            </p>
            <p className="text-lg text-center text-white">
              Open for job postions in Aara Technologies Pvt. Ltd. It Takes a
              new kind of Intelligence to nevigate a new world.
            </p>
            <div className="pt-8">
              {data?.map((card,index) => {
                return (
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography>{card?.Title}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                       <img src={card.images} />
                        <br/>
                        <p>1. Year of Experience :</p>
                        
                        <p>{card?.Experience}</p>
                        <br/>
                        <p>2. Job Date :</p>
                        
                        <p>{card?.created_at}</p>
                        <br/>
                        <p>3. Eligibility :</p>
                        <div dangerouslySetInnerHTML={{ __html: card.Content }} />
                        {/* <ShareLink url={window.location.href} variantImage={card.images} variantName={card.Title}/> */}
                       
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                );
              })}

              
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Career;

